import React, { useEffect, useState } from 'react'
import { redirect } from './redirect'
import { getItem } from './storage'
import { SIGNIN } from '../routes'
import { getCustomerType } from './customer'
import { auth_test } from '@bigyellow/api/auth'

export function requiresAuth(WrappedComponent) {

    const isValidUser=(inUser)=>{

        return  !!(inUser && inUser.id);

    }


    return function (props) {
        const [user, setUser] = useState(null);
        const [customerType, setCustomerType] = useState(null);

        const http_client = props?.store?.get('http_client');


        const checkValidSession = () => {

            (async () => {
                try {
                    // if this returns 401, then the interceptor will redirect to login
                    await auth_test(http_client);
                } catch (error) {
                }
            })()
        }

        useEffect(() => {
            window.addEventListener("focus", function (event) {
                checkValidSession()
            });

        }, []);
        useEffect(() => {
            //just to make it quicker to load the data
            let savedUser = props?.store?.get('user');
            if(isValidUser(savedUser))
            {
                setUser(savedUser);
                setCustomerType(getCustomerType(savedUser));
            }

            // compare the user with what we have stored when user logged in, the saved data might be invalid 
            async function syncUser() {
                let loggedInUser = await getItem('user');
                const userIsLoggedIn = isValidUser( loggedInUser);
                props?.store?.set('user', loggedInUser);
                if(!userIsLoggedIn)
                {
                    redirect(SIGNIN);
                }
                else{
                    if(!isValidUser(savedUser) ||(isValidUser(savedUser) && loggedInUser.id !== savedUser.id ))
                    {
                        setUser(loggedInUser);
                        setCustomerType(getCustomerType(savedUser));
                    }
                }
            }

            syncUser();
        }, [props.store]);

        if (!user) {
            return null;
        }

        return <WrappedComponent customerType={customerType} user={user} {...props} />;
    };
}